
export class ReferenceImageList {
  public src: any = '';
  public file: File = null;
  public fileName: string = <string>'';
  public photoInstructContents: string = <string>'';
  public registeredImageFileFlg: boolean = <boolean>false;
}
